import $ from 'jquery';
import { mountTarget } from '../../components/mountable';

import { ConnectedBasePage } from './connector';
import { LoadableProgressPage } from '../ProgressPage/loadable';
import { showUploadProfilePhotoModal } from '../../components/UploadProfilePhotoModal/loadable';
import { loadable } from '../../components/loadable';
import { Spinner } from '../../components/Spinner/Spinner';
import { dataLoader } from '../../utilities/dataLoader';

const LoadableBlankSlate = loadable(() => import('../BlockPage/BlankSlate'), {
  loading: Spinner,
  key: 'HotBlankSlate',
});

const LoadablePostForm = loadable(
  () => import('../../components/Blogs/PostForm/connector'),
  {
    key: 'HotConnectedPostForm',
  }
);

mountTarget(ConnectedBasePage, document.getElementById('base-page-container'));

/* Not all pages have are completely react yet.
   But we can attach components to parts of them so we can incrementally adopt
   react on all existing pages.
*/

/* 2. attach blockpages to #block-container */
$(() => {
  const blockpageComponentContainer = document.getElementById(
    'blockpage-component-container'
  );
  if (blockpageComponentContainer) {
    const options = dataLoader('block-page-data');

    if (options.resourceID) {
      import('../../blockpage-component/blockpage-component').then(
        ({ BlockpageComponent }) => {
          BlockpageComponent.initialMount(options);
        }
      );
    } else {
      // TODO: 404 - can't do squat
      // if !editor > engine/pagesv2/notFound.html
      // not an issue at the moment since it's handled by PagePresenter
      // 404 - editor can create a page
      mountTarget(LoadableBlankSlate, blockpageComponentContainer, {
        pagePath: options.path,
        pagePathCS: window.location.pathname,
      });
    }
  }
});

// 4. Attach to progress-page element on /progress/
$(() => {
  const elems = document.getElementsByTagName('progress-page');
  if (elems.length) {
    mountTarget(LoadableProgressPage, elems[0]);
  }
});

/* 6. manage my enrolments page */
$(() => {
  const elem = document.getElementById('manage-my-enrolments-mount');

  if (elem) {
    import('../ManageMyEnrolmentsPage/connector').then(
      ({ ConnectedManageMyEnrolments }) => {
        mountTarget(ConnectedManageMyEnrolments, elem);
      }
    );
  }
});

/* 7. legacy page modals */
$(() => {
  const mountLegacyPageModal = (
    buttonId,
    mountId,
    importThunk,
    componentName
  ) => {
    const button = document.getElementById(buttonId);
    // The mount element determines if we are using the webpack version of this
    // modal. It also provides the props.
    const mount = document.getElementById(mountId);

    if (button && mount) {
      importThunk().then((exported) => {
        const props = Object.assign({}, mount.dataset);
        // buttons parent element only has a single child
        mountTarget(exported[componentName], button.parentElement, props);
      });
    }
  };

  // revert revision
  mountLegacyPageModal(
    'revertPageBtn',
    'revert-page-modal-mount',
    () => import(`../../../legacy/loaders/js-page-revert-revision-modal`),
    'RevertPageRevisionModal'
  );

  // thumbnail
  mountLegacyPageModal(
    'addThumbnail',
    'page-thumbnail-modal-mount',
    () => import(`../../../legacy/loaders/js-page-thumbnail-modal`),
    'PageThumbnailModal'
  );

  // list subpages
  mountLegacyPageModal(
    'listSubpages',
    'page-list-subpages-modal-mount',
    () => import(`../../../legacy/loaders/js-page-list-subpages-modal`),
    'ListSubpagesModal'
  );

  // add subpages
  mountLegacyPageModal(
    'addSubpage',
    'page-add-subpages-modal-mount',
    () => import(`../../../legacy/loaders/js-page-add-subpages-modal`),
    'AddSubpagesModal'
  );
});

/* 8. blog post form */
$(() => {
  const newPostButton = document.getElementById('newBlogPost');
  const mount = document.getElementById('newBlogPostArea');

  if (!mount || !newPostButton) {
    return;
  }

  let isVisible = false;

  const doMount = () => {
    const props = Object.assign({}, mount.dataset, {
      isVisible,
      onCancel: () => {
        // simply hide the form again
        $(newPostButton).trigger('click');
      },
    });

    // fix string > number
    props.totalSubscribers = parseInt(props.totalSubscribers || 0, 10);
    props.isAnnouncements = !!props.isAnnouncements;

    mountTarget(LoadablePostForm, mount, props);
  };

  // initial mount
  doMount();

  // some legacy stuff to deal with
  $(newPostButton).click(() => {
    // change input props and remount
    isVisible = !isVisible;
    doMount();

    // in course announcements, hide the 'Add blog post' wrapper
    $(newPostButton).parent('.page-options-extra').hide();

    // hide "This is your course! You can add new announcements" message on course homepage
    $('#newBlogPostText').hide();
  });

  if (window.location.hash === '#newPost') {
    $(newPostButton).trigger('click');
  }
});

/* 10. change profile picture modal */
$(() => {
  // there is actually a page dedicated to changing your profile picture
  // at https://www.openlearning.com/accounts/profile_image/
  if (window.location.pathname === '/accounts/profile_image/') {
    showUploadProfilePhotoModal();
  }

  // sidebar/newStats.html (course bar with profile pic, karma, cohort switcher)
  // accounts/settings/main.html (user account settings)
  $('body').on('click', '.launch-change-profile-picture-modal', () => {
    showUploadProfilePhotoModal();
  });
});
